<template>
    <div class="full-modal">
        <div class="btn-exit grow-medium" @click="ExitModal"><i class="pi pi-times"></i></div>
        <h1 class="top-text">Add Benefit</h1>
        <div class="add-existing" v-if="!createNewBenefit">
            <h3>Select a code to add</h3>
            <select v-model="selectedDropDownItem" class="hover-grow" :class="{'input-incorrect': (this.userTriedToClick && this.selectedDropDownItem === '')}">
                <!-- Placeholder option -->
                <option disabled value="">Select code</option>
                <option v-for="(code, index) in codes" :key="index" :value="code">{{ code.code }} - {{ code.name }}</option>
                <option :value="'ADD_NEW'" v-if="!availableBenefits">+ Add New Benefit</option>
            </select>
            <div class="data-row" v-if="availableBenefits && selectedDropDownItem && selectedDropDownItem !== 'ADD_NEW'">
                <h4 class="data-row-text">Desired Payout:</h4>
                <div class="input-with-prefix">
                    <span class="dollar-sign">$</span>
                    <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.selectedPayout === 0 && this.userTriedToClick)}" type="text" v-model="selectedPayout" @input="ValidatePrice($event, 'selectedPayout')"/>
                    
                </div>
            </div>
            <button class="submit-btn hover-grow" @click="AddExistingBenefit">Add Benefit</button>
        </div>
        <div class="add-new" v-else>
            <div class="data-row">
                <h4 class="data-row-text">Name:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.name === '' && this.userTriedToClick)}" type="text" v-model="benefit.name"/>
            </div>
            <!-- <div class="data-row">
                <h4 class="data-row-text">Technical Name:</h4>
                <input class="data-row-input" type="text" v-model="benefit.technicalName"/>
            </div> -->
            <div class="data-row">
                <h4 class="data-row-text">Code:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': ((this.benefit.code === '' && this.userTriedToClick) || codeAlreadyExists)}" type="text" v-model="benefit.code"/>
            </div>
            <div class="data-row">
                <h4 class="data-row-text">Include with each visit?</h4>
                <div class="checkbox-container grow-medium" style="position:relative;">
                    <div class="checkbox" @click="toggleChecked()">
                        <div class="checkbox-fill" v-if="this.benefit.isWithPlan">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-row" v-if="!this.benefit.isWithPlan">
                <h4 class="data-row-text no-select">Frequency:</h4>
                <div>
                    Every &nbsp;<input class="data-row-input hover-grow" style="width: 2.5em;" :class="{'input-incorrect': (this.benefit.price === 0 && this.userTriedToClick)}" type="text" v-model="benefit.frequency" @input="ValidatePrice($event, 'frequency')"/> &nbsp;Months
                </div>
            </div>
            <div class="data-row">
                <h4 class="data-row-text">UCR:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.UCR === 0 && this.userTriedToClick)}" type="text" v-model="benefit.UCR" @input="ValidatePrice($event, 'UCR')"/>
            </div>
            <div class="data-row">
                <h4 class="data-row-text">Desired Payout:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.price === 0 && this.userTriedToClick)}" type="text" v-model="benefit.price" @input="ValidatePrice($event, 'price')"/>
            </div>
                <button class="submit-btn hover-grow" @click="AddNewBenefit">Add Benefit</button>
                <div class="modal-bottom-spacer"></div>
            </div>
            <p class="error-message" v-if="!createNewBenefit" :class="{ 'hidden': !hasDefaultValues || !userTriedToClick }">Please select a benefit to add</p>
            <p class="error-message" v-else :class="{ 'hidden': !hasDefaultValues || !userTriedToClick }">Please fill out all fields to add this benefit</p>
            <p class="error-message" :class="{ 'hidden': !codeAlreadyExists }">A benefit with this code already exists</p>

    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { canBenefitHaveMultipleQuantity } from '../../utils/functions';
export default {
    props: {
        planType: Number,
        availableBenefits: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            benefit: {
                name: "",
                technicalName: "",
                code: "",
                isWithPlan: false,
                UCR: 0,
                price: 0,
                frequency: 6,
            },
            selectedOption: "Add Existing Benefit",
            createNewBenefit: false,
            selectedDropDownItem: "",
            userTriedToClick: false,
            inputClasses: {
                'data-row-input': true,
                'hover-grow': true,
            },
            codeAlreadyExists: false,
            selectedPayout: 0
        }
    },
    mounted() {
        window.addEventListener('keydown', this.handleEscape);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscape);
    },
    methods: {
        ...mapActions(['addBenefitStore', 'updateBenefitByIDStore']),
        ExitModal() {
            this.$emit('exitModal');
        },
        AddExistingBenefit() {
            if(this.selectedDropDownItem === ""){
                this.userTriedToClick = true;
                if(this.userTriedToClick && this.selectedDropDownItem === ''){
                    console.log("Error conditions met- turn the select red");
                }
                return;
            }
            let newBenefit = this.selectedDropDownItem;
            
            // If we're using passed-in benefits, emit the selected benefit with payout
            if (this.availableBenefits) {
                this.$emit('benefitAdded', {
                    ...newBenefit,
                    payout: this.selectedPayout
                });
                this.ExitModal();
                return;
            }

            // Otherwise, use the VueX store logic (clone so we don't mutate store)
            const benefit = this.$store.getters.getBenefitByID(newBenefit.id) || newBenefit;
            const updated = JSON.parse(JSON.stringify(benefit));
            const planTypes = [...(updated.planTypes || [])];
            const entry = planTypes.find(e => e.planTypeIndex === this.planType);
            if (entry) {
                if (!canBenefitHaveMultipleQuantity(benefit)) {
                    this.ExitModal();
                    return;
                }
                entry.quantity += 1;
            } else {
                planTypes.push({ planTypeIndex: this.planType, quantity: 1 });
                if (!updated.frequencies) updated.frequencies = {};
                updated.frequencies[this.planType] = this.$store.getters.getDefaultBenefitFrequency(updated);
            }
            updated.planTypes = planTypes;
            if (!updated.price) {
                updated.price = this.selectedPayout || Math.ceil(updated.UCR * 0.7);
            }
            this.updateBenefitByIDStore(updated);
            this.ExitModal();
        },
        AddNewBenefit() {
            this.userTriedToClick = true;
            if(this.hasDefaultValues) {
                return;
            }

            // If using passed-in benefits, check for duplicate codes in those benefits
            if (this.availableBenefits) {
                if (this.availableBenefits.some(b => b.code === this.benefit.code)) {
                    this.codeAlreadyExists = true;
                    return;
                }
            } else if(this.$store.getters.existsCode(this.benefit.code)) {
                this.codeAlreadyExists = true;
                return;
            }

            let newBenefit = { ...this.benefit };

            // If using passed-in benefits, emit the new benefit
            if (this.availableBenefits) {
                this.$emit('benefitAdded', newBenefit);
                this.ExitModal();
                return;
            }

            // Otherwise, use the VueX store logic (new format: array of { planTypeIndex, quantity })
            newBenefit.planTypes = [{ planTypeIndex: this.planType, quantity: 1 }];
            newBenefit.price = this.benefit.price;
            newBenefit['frequencies'] = {};
            newBenefit.frequencies[this.planType] = newBenefit.frequency;
            if(this.benefit.isWithPlan) {
                newBenefit.frequencies[this.planType] = -1;
            }
            delete(newBenefit.frequency);
            this.addBenefitStore(newBenefit)
            this.ExitModal();
        },
        ValidatePrice(event, fieldName) {
            const cleanedPrice = event.target.value.replace(/\D/g, '');
            if (fieldName === 'selectedPayout') {
                this.selectedPayout = parseInt(cleanedPrice, 10) || 0;
            } else {
                this.benefit[fieldName] = parseInt(cleanedPrice, 10) || 0;
            }
        },
        handleEscape(event) {
            if(event.key === 'Escape') {
                this.ExitModal();
            }
        },
        toggleChecked() {
            this.benefit.isWithPlan = !this.benefit.isWithPlan;
        }
    },
    computed: {
        codes() {
            // If availableBenefits prop is provided, use it
            if (this.availableBenefits !== null) {
                return this.availableBenefits;
            }
            
            // Otherwise, use the VueX store logic
            let result = this.$store.state.benefits
            // result = result.filter(benefit => !benefit.planTypes.includes(this.planType))
            return result
        },
        hasDefaultValues() {
            if(this.benefit.name === "" || this.benefit.code === "" || this.benefit.UCR === 0 || this.benefit.price === 0) {
                return true;
            }
            else {return false;}
        },
    },
    watch: {
    selectedDropDownItem(newVal, oldVal) {
        if(newVal === 'ADD_NEW') {
            this.createNewBenefit = true;
        }
    }
}
}
</script>

<style scoped>

.full-modal {
    position: relative;
    width: 30%;
    min-width: 280px;
    max-height: 90vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    border: 3px solid var(--color-dark-blue);
    outline: 2px solid white;
    padding: 2%;
    overflow-y: auto;
    box-sizing: border-box;
}

.btn-exit {
    position: absolute;
    top: 20px;
    right: 25px;
    color: red;
    font-size: 1.75em;
    cursor: pointer;
    font-family: sans-serif
}

.top-text {
    color: var(--font-color-teal);
    margin-top: 0.25em;
    flex-shrink: 0;
}

.add-existing {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
}

select {
    background-color: white;
    border: 2px solid var(--color-light-gray);
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 16px;
    cursor: pointer;
}

select:hover {
    border: 2px solid var(--color-light-blue);
}

.add-new {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
}

.data-row{
    width: 85%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 3.5em;
    flex-shrink: 0;
}

.data-row-text {
    font-size: 1.2em;
}

.data-row-input {
    height: 20px;
    border-radius: 5px;
    border: 2px solid var(--color-medium-light-gray);
    transition: border-color 0.2s ease;
}

.input-incorrect {
    border: 2px solid var(--color-light-red) !important;
}

.data-row-input:hover {
    border: 2px solid var(--color-light-blue);
}

.data-row-input:focus {
    outline: none;
    border: 2px solid var(--color-bright-blue);
}

.submit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid var(--color-light-blue);
    border-radius: 40px;
    height: 2.25em;
    background-color: white;
    color: var(--color-bright-blue);
    font-size: 1.4em;
    font-weight: 600;
    padding-right: 0.7em;
    padding-left: 0.7em;
    cursor: pointer;
    margin-top: 1em;
    box-shadow: 3px 3px 5px var(--color-light-gray);
    flex-shrink: 0;
}

.submit-btn:active {
    border: 3px solid var(--color-dark-blue)
}

.error-message {
    margin: 0;
    color: var(--color-medium-red);
    flex-shrink: 0;
}

.error-message.hidden {
    visibility: hidden;
}

.modal-bottom-spacer {
    min-height: 0.5em;
    flex-shrink: 0;
}

.checkbox-container {
    cursor: pointer;
    position: relative;
    width: auto;
    height: 25px;
    margin-right: 85px;
}

.checkbox {
    position: absolute;
    width: 25px;
    height: 25px;
    border: 2px solid var(--color-dark-blue);
    border-radius: 5px;
    margin: 0;
}

.checkbox-fill {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 23px;
    height: 23px;
    background-color: var(--color-dark-blue);
    border-radius: 3px;
    color: white;
}

.checkbox-text {
    margin: 0;
    position: absolute;
    font-size: 1.5em;
    left: 2px;
    top: -3px;
}

.input-with-prefix {
    display: flex;
    align-items: center;
    gap: 0.5em;
}

.dollar-sign {
    color: var(--color-dark-blue);
    font-weight: 600;
    font-size: 1.2em;
}

.input-with-prefix input {
    width: 100px;
}
</style>